<template>
  <!-- NOTE (TEMPLATE) to show the topics list -->

  <div class="animated fadeIn">
    <b-card v-if="$router.currentRoute.path == '/head/topics'">
      <b-tabs pills>
        <b-tab title="رسته‌ها" active>
          <!-- NOTE (b-addRasteh) to add new "rasteh" to the table of "rasteh" -->
          <!-- <b-button
            variant="success"
            @click="openAdd1()"
            style="float: right"
            class="my-2"
            ><strong>افزودن رسته +</strong></b-button
          > -->
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="filter1"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <!-- NOTE (b-delete) to delete the text of the search bar -->
                <b-button
                  :disabled="!filter1"
                  @click="filter1 = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-rasteh) to show the "rasteh" list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fields1"
            :items="items1"
            :current-page="currentPage1"
            :per-page="perPage1"
            empty-text="هنوز طرحی ثبت نشده است"
            striped
            :busy="isBusy1"
            :filter="filter1"
            @filtered="onFiltered1"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage1 * (currentPage1 - 1) + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  width: 150px;
                  margin: auto;
                "
              >
                <!-- NOTE (b-editRasteh) to edit rasteh -->
                <b-button
                  variant="warning"
                  style="width: 100%"
                  @click="openEdit1(data.item)"
                  >ویرایش</b-button
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage1"
            :total-rows="totalRows1"
            :per-page="perPage1"
            first-text="ابتدا"
            prev-text="قبلی"
            next-text="بعدی"
            last-text="آخر"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-tab>
        <b-tab title="موضوعات">
          <!-- NOTE (b-addSubject) to add new subject -->
          <!-- <b-button
            variant="success"
            @click="openAdd2()"
            style="float: right"
            class="my-2"
            ><strong>افزودن موضوع جدید +</strong></b-button
          > -->
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="filter2"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <!-- NOTE (b-delete) to delete the text of the search bar -->
                <b-button
                  :disabled="!filter2"
                  @click="filter2 = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-subjects) to show the subjects list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fields2"
            :items="items2"
            :current-page="currentPage2"
            :per-page="perPage2"
            empty-text="هنوز طرحی ثبت نشده است"
            striped
            :busy="isBusy2"
            :filter="filter2"
            @filtered="onFiltered2"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage2 * (currentPage2 - 1) + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  width: 150px;
                  margin: auto;
                "
              >
                <!-- NOTE (b-editSubject) to edit subject -->
                <b-button
                  style="width: 100%"
                  variant="warning"
                  @click="openEdit2(data.item)"
                  >ویرایش</b-button
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage2"
            :total-rows="totalRows2"
            :per-page="perPage2"
            first-text="ابتدا"
            prev-text="قبلی"
            next-text="بعدی"
            last-text="آخر"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-tab>
        <b-tab title="محورها">
          <!-- NOTE (b-addMehvar) to add new mehvar -->
          <!-- <b-button
            variant="success"
            @click="openAdd3()"
            style="float: right"
            class="my-2"
            ><strong>افزودن محور جدید +</strong></b-button
          > -->
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="filter3"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  :disabled="!filter3"
                  @click="filter3 = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-mehvars) to show the mehvars list -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fields3"
            :items="items3"
            :current-page="currentPage3"
            :per-page="perPage3"
            empty-text="هنوز طرحی ثبت نشده است"
            striped
            :busy="isBusy3"
            :filter="filter3"
            @filtered="onFiltered3"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage3 * (currentPage3 - 1) + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  width: 150px;
                  margin: auto;
                "
              >
                <!-- NOTE (b-editMehvar) to edit mevar -->
                <b-button
                  style="width: 100%"
                  variant="warning"
                  @click="openEdit3(data.item)"
                  >ویرایش</b-button
                >
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage3"
            :total-rows="totalRows3"
            :per-page="perPage3"
            first-text="ابتدا"
            prev-text="قبلی"
            next-text="بعدی"
            last-text="آخر"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-tab>
      </b-tabs>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
import Select2 from "v-select2-component";
import { ModelSelect } from "vue-search-select";

export default {
  components: {
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
    Select2,
    ModelSelect,
  },
  data: function () {
    return {
      perPage1: 10,
      currentPage1: 1,
      totalRows1: 1,
      perPage2: 10,
      currentPage2: 1,
      totalRows2: 1,
      perPage3: 10,
      currentPage3: 1,
      totalRows3: 1,
      fields1: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "رسته" },
        { key: "description", label: "توضیحات" },
        // { key: "operation", label: "عملیات" }
      ],
      items1: [],
      filter1: "",
      isBusy1: true,
      fields2: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "موضوع" },
        { key: "mainCat", label: "رسته" },
        // { key: "operation", label: "عملیات" }
      ],
      items2: [],
      filter2: "",
      isBusy2: true,
      states: [
        { value: "فعال", eng: "active", text: "فعال" },
        { value: "غیرفعال", eng: "deactive", text: "غیرفعال" },
      ],
      fields3: [
        { key: "index", label: "ترتیب" },
        { key: "name", label: "محور" },
        { key: "cat", label: "موضوع" },
        { key: "university", label: "نام دانشگاه" },
        { key: "contractNo", label: "شماره تفاهم‌نامه" },
        { key: "date", label: "تاریخ قرارداد" },
        { key: "status", label: "وضعیت" },
        // { key: "operation", label: "عملیات" }
      ],
      items3: [],
      filter3: "",
      isBusy3: true,
      newRaste: "",
      newRasteDesc: "",
      newMozou: "",
      newMozouRaste: "",
      newMehvar: "",
      newMehvarMozou: "",
      newMehvarUniversity: "",
      newMehvarNumber: "",
      newMehvarDate: "",
      selected: {},
    };
  },

  methods: {
    getData() {
      // NOTE (m-getData) to get the data of this page

      this.$http
        .post(
          this.baseUrl + "/setad/head/mainCats/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items1 = res.data;
          this.isBusy1 = false;
          this.totalRows1 = this.items1.length;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });

      this.$http
        .post(
          this.baseUrl + "/setad/head/cats/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items2 = res.data;
          this.totalRows2 = this.items2.length;
          this.isBusy2 = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });

      this.$http
        .post(
          this.baseUrl + "/setad/head/mehvars/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items3 = res.data;
          this.isBusy3 = false;
          this.totalRows3 = this.items3.length;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    onFiltered2(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows2 = filteredItems.length;
      this.currentPage2 = 1;
    },
    onFiltered3(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows3 = filteredItems.length;
      this.currentPage3 = 1;
    },
    openAdd1() {
      // NOTE (m-openAdd1) to show loading
      this.$refs["add1"].show();
    },
    doAdd1() {
      // NOTE (m-doAdd1) to add new rasteh
      this.$http
        .post(
          this.baseUrl + "/setad/head/mainCat/new",
          {
            name: this.newRaste,
            description: this.newRasteDesc,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy1 = true;
          this.toast(res.data, "success");
          this.newRaste = "";
          this.newRasteDesc = "";
          this.$refs["add1"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openEdit1(item) {
      // NOTE (m-openEdit1) to specify selected rasteh
      this.selected = JSON.parse(JSON.stringify(item));
      this.$refs["edit1"].show();
    },
    doEdit1() {
      // NOTE (m-doEdit1) to edit the rasteh
      this.$http
        .post(
          this.baseUrl + "/setad/head/mainCat/edit",
          {
            mainCatId: this.selected.id,
            name: this.selected.name,
            description: this.selected.description,
            status: "active",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy1 = true;
          this.toast(res.data, "success");
          this.selected = {};
          this.$refs["edit1"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openDelete(item) {
      this.selected = item;
      this.$refs["doDel"].show();
    },
    openAdd2() {
      // NOTE (m-openAdd2) to show loading
      this.$refs["add2"].show();
    },
    doAdd2() {
      // NOTE (m-doAdd2) to add new subject
      this.$http
        .post(
          this.baseUrl + "/setad/head/cat/new",
          {
            name: this.newMozou,
            mainCatId: this.newMozouRaste,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy2 = true;
          this.toast(res.data, "success");
          this.newMozou = "";
          this.newMozouRaste = "";
          this.$refs["add2"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openEdit2(item) {
      // NOTE (m-openEdit2) to specify selected subject
      this.selected = JSON.parse(JSON.stringify(item));
      this.$refs["edit2"].show();
    },
    doEdit2() {
      // NOTE (m-doEdit2) to edit subject
      this.$http
        .post(
          this.baseUrl + "/setad/head/cat/edit",
          {
            catId: this.selected.id,
            name: this.selected.name,
            mainCatId: this.selected.mainCatId,
            status: "active",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy2 = true;
          this.toast(res.data, "success");
          this.selected = {};
          this.$refs["edit2"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openAdd3() {
      // NOTE (m-openAdd3) to show loading
      this.$refs["add3"].show();
    },
    doAdd3() {
      // NOTE (m-doAdd3) to add new subject
      this.$http
        .post(
          this.baseUrl + "/setad/head/mehvar/new",
          {
            catId: this.newMehvarMozou,
            name: this.newMehvar,
            contractDate: this.newMehvarDate,
            contractNumber: this.newMehvarNumber,
            universityId: this.newMehvarUniversity,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          (this.newMehvar = ""),
            (this.newMehvarMozou = ""),
            (this.newMehvarNumber = ""),
            (this.newMehvarDate = "");
          this.isBusy3 = true;
          this.toast(res.data, "success");
          this.newMehvar = "";
          this.$refs["add3"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    openEdit3(item) {
      // NOTE (m-openEdit3) to specify selected mehvar
      this.selected = JSON.parse(JSON.stringify(item));
      this.selected.catId = this.selected.catId;
      this.selected.universityId = this.selected.universityId;
      this.$refs["edit3"].show();
    },
    doEdit3() {
      // NOTE (m-doEdit3) to edit mehvar
      this.$http
        .post(
          this.baseUrl + "/setad/head/mehvar/edit",
          {
            mehvarId: this.selected.id,
            catId: this.selected.catId,
            name: this.selected.name,
            contractDate: this.selected.date,
            contractNumber: this.selected.contractNo,
            universityId: this.selected.universityId,
            status: this.states.filter(
              (x) => x.value == this.selected.status
            )[0].eng,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.isBusy3 = true;
          this.toast(res.data, "success");
          this.selected = {};
          this.$refs["edit3"].hide();
          this.getData();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    hideModal(type) {
      this.$refs[type].hide();
    },
  },

  mounted() {
    // NOTE (MOUNTED) to show the data of this page
    this.getData();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
.select2-search__field {
  z-index: 20000;
}
</style>
